// src/v3/interactions/chevron-up.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ChevronUpIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "ChevronUpIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.1302 15.8045C19.0683 15.8665 18.9948 15.9156 18.9138 15.9492C18.8329 15.9827 18.7462 16 18.6586 16C18.571 16 18.4842 15.9827 18.4033 15.9492C18.3224 15.9156 18.2489 15.8665 18.187 15.8045L11.9928 9.60948L5.79859 15.8045C5.67351 15.9296 5.50387 15.9998 5.32698 15.9998C5.1501 15.9998 4.98046 15.9296 4.85538 15.8045C4.7303 15.6794 4.66003 15.5098 4.66003 15.3329C4.66003 15.156 4.7303 14.9864 4.85538 14.8613L11.5212 8.1955C11.5831 8.13352 11.6566 8.08436 11.7375 8.05081C11.8184 8.01727 11.9052 8 11.9928 8C12.0804 8 12.1671 8.01727 12.248 8.05081C12.329 8.08436 12.4025 8.13352 12.4644 8.1955L19.1302 14.8613C19.1922 14.9232 19.2413 14.9967 19.2749 15.0776C19.3084 15.1586 19.3257 15.2453 19.3257 15.3329C19.3257 15.4205 19.3084 15.5072 19.2749 15.5882C19.2413 15.6691 19.1922 15.7426 19.1302 15.8045Z"
  }
) });

export {
  ChevronUpIcon
};
